import PropTypes from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { t } from '../../modules/infra/i18n';

const Pagination = ({ onPageChange, pageCount, currentPage }) => (
  <ReactPaginate
    containerClassName="react-paginate"
    pageLinkClassName="react-paginate-item"
    previousLinkClassName="react-paginate-item"
    nextLinkClassName="react-paginate-item"
    breakLinkClassName="react-paginate-item"
    activeLinkClassName="react-paginate-item is-active"
    disabledClassName="react-paginate-disabled"
    previousLabel={t('common:pagination.previous')}
    nextLabel={t('common:pagination.next')}
    pageCount={pageCount}
    forcePage={currentPage - 1}
    onPageChange={data => onPageChange(data.selected + 1)}
    marginPagesDisplayed={8}
    pageRangeDisplayed={4}
  />
);

Pagination.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default Pagination;
